import * as yup from 'yup';

export const groupsUsersSchema = yup.object().shape({
  name: yup.string().required('maintenance.course.form.name.required'),
  keyword: yup.string().required('maintenance.course.form.keyword.required'),
  eva_type_uuid: yup.string().required('maintenance.course.form.eva_type_uuid.required'),
});
